import React, {useEffect, useState, useRef} from 'react';
import CoreLoaderMain from "./CoreLoaderMain";
import CoreLoaderDelay from "./CoreLoaderDelay";

const CoreLoader = ({ onFinish }) => {

    const [delayed, setDelayed] = useState(false);
    const [finished, setFinished] = useState(false);

    const timeoutRef = useRef(null);

    const handleFinish = () => {
        setFinished(true);
        if (onFinish) onFinish();
    };

    useEffect(() => {
        timeoutRef.current = setTimeout(() => {
            if (!finished) {
                setDelayed(true);
            }
        }, 2000);

        return () => clearTimeout(timeoutRef.current);
    }, [finished]);

    if (finished) return null;

    return (
        <>
            {delayed
                ? <CoreLoaderDelay onFinish={handleFinish}/>
                : <CoreLoaderMain onFinish={handleFinish}/>
            }
        </>
    );
};

export default CoreLoader;
